<template>
  <div class="fixed-page">
    <!-- 工具栏 -->
    <toolbar ref="bar" :sourceData="barData" @initCallback="initBarCallback" @onFilter="handleFilter"></toolbar>

    <div class="app-container" :style="{'margin-top': barHeight}">
      <!-- 工具栏 -->
      <div class="filter-container" v-if="currentRoute.meta.shared">
        <el-button class="filter-item" size="mini" icon="el-icon-circle-plus-outline" @click="handleAddTransfer">添加</el-button>
        <el-button class="filter-item" size="mini" icon="el-icon-upload2" @click="handleShareTransfer">共享</el-button>
      </div>
      
      <!-- 尚未添加报表 -->
      <div class="empty-box" v-if="!isModel && currentRoute.meta.shared">
        <svg-icon icon-class="zhuangxiang" class="icon" />
        <div class="text">尚未添加报表</div>
        <el-button class="butn" size="mini" icon="el-icon-circle-plus-outline" @click="handleAddTransfer">添加</el-button>
      </div>

      <!-- 模块 -->
      <module-card ref="card" source="menu" @handleModel="handleModel" @addTabs="handleTabsTransfer"></module-card>

      <!-- 右侧抽屉组件 -->
      <apply-transfer ref="apply" :size="transferSize" :source="transferSource" :title="applyTitle" @repeatList="getModule"></apply-transfer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Toolbar from "../gameData/components/toolbar"
import ApplyTransfer from './components/applyTransfer.vue'
import ModuleCard from "../gameData/components/module/moduleCard"
import {codeControl} from '@Bdc~/api/ajax_model'
import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
export default {
  name:name,
  components:{ApplyTransfer, ModuleCard, Toolbar},
  data() {
    return {
      applyTitle:'',
      isModel: false,
      transferSource:'',
      transferSize:'',
      barHeight: '', // 筛选条件高度

      barData:[],
      barLoading: true,
      currentRoute: this.$store.getters.currentRoute
    }
  },

  computed: {
    ...mapGetters(['transitionEnter']),
  },

  watch: {
    transitionEnter(val) {
      // console.log(val)
      if(val == 1 && this.$refs.bar) {
        this.barHeight = this.$refs.bar.$el.offsetHeight + 'px'
      } else {
        this.barHeight = 0
      }
    }
  },

  created() {
    this.getList()
    // console.log('====',this.currentRoute)
  },

  mounted() {
    window.onresize = () => {
      // console.log('1111fixedHeight', this.$refs.bar.$el.offsetHeight)
      this.barHeight = this.$refs.bar.$el.offsetHeight + 'px'
    }
  },

  methods: {

    // 获取工具栏（筛选项）
    getList() {
      codeControl().then(response => {
        if(response.code == 1) {
          this.barData = response.data
          // console.log('工具栏11111：',this.barData)
          this.$nextTick(() => {
            this.$refs['bar'].init() // 初始化
          })
        }
      })
    } ,

    initBarCallback() {
      if(this.$refs.bar) {
        this.barHeight = this.$refs.bar.$el.offsetHeight + 'px'
      }
    },

    // 查询
    handleFilter(val) {
      this.$refs['card'].getModule(val)
    },

    // 获取模块列表数据展示
    getModule() {
      this.$refs['card'].getModule()
    },

    // 添加
    handleAddTransfer() {
      this.applyTitle = '添加'
      this.transferSource="add"
      this.transferSize = '700px'
      this.$refs['apply'].init()
    },

    // 共享
    handleShareTransfer() {
      this.applyTitle = '共享'
      this.transferSource="share"
      this.transferSize = '400px'
      this.$refs['apply'].init()
    },

    // 添加tabs 指标
    handleTabsTransfer(item) {
      this.applyTitle = item.name
      this.transferSource="addTabs"
      this.transferSize = '700px'
      this.$refs['apply'].init(item.id)
    },

    // 接收model
    handleModel(val) {
      this.isModel = val
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-page{
  overflow: hidden;
}

  .app-container{
    min-height: calc(100vh - 84px);
    background:#f9f9f9
  }
  .filter-item{
    margin-right: 0;
  }
  // 空
  .empty-box{
    margin: 20vh auto;
    width: 300px;
    height: 200px;
    background: #ffffff;
    overflow: hidden;
    .icon{
      display: block;
      width: 100px;
      height: 100px;
      margin: 10px auto;
    }
    .text{
      display: block;
      font-size: 14px;
      color: #1890ff;
      width: 100%;
      text-align: center;
    }
    .butn{
      display: block;
      margin: 10px auto;
    }
  }
</style>